"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeroImageSlider = /** @class */ (function () {
    function HeroImageSlider() {
        this.$owl = $('#hero-banner--carousel');
        this.initCarousel();
    }
    HeroImageSlider.prototype.initCarousel = function () {
        var _this = this;
        this.$owl.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: false,
            autoplay: true,
            dots: true,
            loop: true,
        });
        $('.custom-owl-nav__prev').click(function () { return _this.$owl.trigger('prev.owl.carousel', [300]); });
        $('.custom-owl-nav__next').click(function () { return _this.$owl.trigger('next.owl.carousel', [300]); });
    };
    return HeroImageSlider;
}());
exports.default = HeroImageSlider;
